import "extensionsjs/lib";
import { createRoot } from "react-dom/client";
import "./styles/index.less";
import "react-quill/dist/quill.snow.css";
import reportWebVitals from "./reportWebVitals";
import AppRoot from "./routers/AppRoot";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<AppRoot />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
